"use client";

import TabbedContent from "@/app/(components)/generics/TabbedContent/TabbedContent";
import Account from "@/app/(components)/specifics/settings/Settings/tabs/Account";
import Practitioner from "@/app/(components)/specifics/settings/Settings/tabs/Practitioner";
import { UserStore } from "@/app/stores/UserStore";
import { TKey } from "@/app/translations/TKey";
import { T } from "@/app/translations/Translations";
import styles from "./Settings.module.css";

type Props = { lang: string; initialTab?: string };

export default function Settings({ lang, initialTab }: Props) {
  const user = UserStore((state) => state.user);

  if (!user) return null;

  const tabs = [
    {
      id: "account",
      title: T(TKey.SETTINGS_ACCOUNT, lang) as string,
      content: <Account lang={lang} />,
    },
    {
      id: "practitioner",
      title: T(TKey.SETTINGS_PRACTITIONER, lang) as string,
      content: <Practitioner lang={lang} />,
    },
  ];

  return (
    <div className={styles.container}>
      <TabbedContent items={tabs} initialItemId={initialTab} />
    </div>
  );
}
